import Vue from 'vue'

const state = {
    statistics: {
        incomeDaily:     0,
        incomeWeekly:    0,
        incomeMonthly:   0,
        turnoverDaily:   0,
        turnoverWeekly:  0,
        turnoverMonthly: 0
    }
}

const getters = {
    statistics: state => {
        return state.statistics
    }
}

const mutations = {
    setStatistics (state, data) {
        Vue.set(state, 'statistics', {
            incomeDaily:     data.income_daily,
            incomeWeekly:    data.income_weekly,
            incomeMonthly:   data.income_monthly,
            turnoverDaily:   data.turnover_daily,
            turnoverWeekly:  data.turnover_weekly,
            turnoverMonthly: data.turnover_monthly
        })
    }
}

const actions = {}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/statistics.js